import * as angular from "angular";
import {BringozApi} from "../../persistence-layer/models/bringoz-api.model";

angular
  .module('bringoz.admin.deliveries')
  .factory('DeliveriesMessagesAPI', DeliveriesMessagesAPI);

function DeliveriesMessagesAPI(): BringozApi {
  return {
    base: `/messages/service-sms`,
    infiniteScroll: {
      address: `/messages/service-sms`,
      cmd: 'GET'
    },
    actions: {
      send: {
        address: '',
        cmd: 'POST',
        updateable: false
      }
    }
  }
}
